module.exports = __webpack_public_path__ + "static/media/error_404_mobile.4dbaa30e.svg";